/* unplugin-vue-components disabled */import { render } from "./Process.vue?vue&type=template&id=208ff396"
import script from "./Process.vue?vue&type=script&lang=js"
export * from "./Process.vue?vue&type=script&lang=js"

import "./Process.vue?vue&type=style&index=0&id=208ff396&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__